var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZetaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6597 20.7878V23.7119H9.39619C9.56483 21.7869 10.1965 20.433 12.3796 18.5282L21.6597 10.7402V17.5748H25V5H6.00373V11.2682H9.34308V8.28625H19.4347L10.2003 16.0394L10.1779 16.0596C6.30747 19.4311 6 22.1518 6 25.3573V27H24.9991V20.7887H21.6588L21.6597 20.7878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZetaWhite);
export default __webpack_public_path__ + "static/media/zeta-white.1b6aebc1698b2c834f1de6eabb33be19.svg";
export { ForwardRef as ReactComponent };